export const request = {
  scopes: [process.env.REACT_APP_SCOPE]
};

export const GetAccessToken = async (instance) => {
  try {
    let res = await instance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        localStorage.setItem('authToken', tokenResponse.accessToken);
        return tokenResponse;
      })
      .catch(async (error) => {
        if (error.name === 'InteractionRequiredAuthError') {
          return await instance.acquireTokenRedirect(request);
        }
      });
    sessionStorage.setItem('token', res?.accessToken);
    return {
      token: res?.accessToken,
      email: res?.account?.idTokenClaims?.emails[0]
    };
  } catch (error) {
    console.log(error);
  }
};
